module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', {
    staticClass: "abbre",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("CO")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("John Calvin, "), _c('i', [_vm._v("Ioannis Calvini opera omnia quae supersunt")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Comm")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Communio")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Inst.")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("John Calvin, "), _c('i', [_vm._v("Institutes of the Christian Religion")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("TS")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Theological Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("VF")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Verkündigung und Forschung")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06801598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 75
// module chunks = 0